import React from "react";
import { activityOptions, intensityOptions } from "../helpers/ddOptions";
import { strings } from "../loc/langs";

class EditActivities extends React.Component {
  handleOnChange = event => {
    let activityIndex = parseInt(
      event.currentTarget.attributes.index.value,
      10
    );
    let fieldValue = event.currentTarget.value;

    // Update the activity.
    // Take a copy of the current activity.
    const updatedActivity = {
      ...this.props.stopwatch.activities[activityIndex],
      [event.currentTarget.name]: fieldValue
    };

    // The updateActivity method lives in the StopwatchContainer component (where the state is).
    this.props.updateActivity(
      this.props.stopwatchindex,
      activityIndex,
      updatedActivity
    );
  };

  handleOnClick = event => {
    let activityIndex = parseInt(
      event.currentTarget.attributes.index.value,
      10
    );

    // The deleteActivity method lives in the StopwatchContainer component (where the state is).
    this.props.deleteActivity(this.props.stopwatchindex, activityIndex);
  };

  render() {
    const { activities } = this.props.stopwatch;

    return (
      <div className="edit-activity-container">
        <table className="activities-edit-table">
          <thead>
            <tr>
              <th>
                <div className="icon-name-col">{strings["Activity"]}</div>
              </th>
              <th>
                <div className="duration-col">{strings["Duration"]}</div>
              </th>
              <th>
                <div className="intensity-col">{strings["Intensity"]}</div>
              </th>
              <th>
                <div className="delete-col"></div>
              </th>
            </tr>
          </thead>
          <tbody>
            {activities.map((activity, i) => (
              <tr key={activity.id}>
                <td>
                  <div className="icon-name-col">
                    <select
                      name="icon"
                      index={i}
                      onChange={this.handleOnChange}
                      value={activity.icon}
                      className={`${activity.intensity}`}
                      disabled={activityOptions.length === 1}
                    >
                      {activityOptions.map((option, i) => (
                        <option
                          value={option.value}
                          title={option.title}
                          key={`aEdit${i}`}
                        >
                          {option.label}
                        </option>
                      ))}
                    </select>
                    <input
                      name="name"
                      index={i}
                      onChange={this.handleOnChange}
                      placeholder={strings["TypeInTheNameOfAnActivity"]}
                      value={activity.name}
                      type="text"
                      className={`${activity.intensity}`}
                      onFocus={e => e.target.select()}
                    />
                  </div>
                </td>
                <td>
                  <div className="duration-col">
                    <input
                      name="duration"
                      index={i}
                      onChange={this.handleOnChange}
                      min="0"
                      value={activity.duration}
                      type="number"
                      className={`${activity.intensity}`}
                      onFocus={e => e.target.select()}
                    />
                  </div>
                </td>
                <td>
                  <div className="intensity-col">
                    <select
                      name="intensity"
                      index={i}
                      onChange={this.handleOnChange}
                      value={activity.intensity}
                      className={`${activity.intensity}`}
                    >
                      {intensityOptions.map((option, i) => (
                        <option
                          value={option.value}
                          title={option.title}
                          key={`iEdit${i}`}
                        >
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </div>
                </td>
                <td>
                  <div className="delete-col">
                    <div className="delete-activity-btn-container">
                      <button
                        type="button"
                        index={i}
                        title={strings["DeleteActivity"]}
                        onClick={this.handleOnClick}
                      >
                        <span className="icon">
                          <i className="fas fa-times"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default EditActivities;
